import { createI18n } from "vue-i18n";
import hr from "./locales/hr.json";
import en from "./locales/en.json";

const STORAGE_KEY = "cybro:locale";
const SUPPORTED = ["hr", "en"] as const;
export type SupportedLocale = (typeof SUPPORTED)[number];

function detectInitialLocale(): SupportedLocale {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && (SUPPORTED as readonly string[]).includes(stored)) {
    return stored as SupportedLocale;
  }
  return "hr";
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectInitialLocale(),
  fallbackLocale: "hr",
  messages: { hr, en },
  missingWarn: false,
  fallbackWarn: false,
});

export function setLocale(loc: SupportedLocale): void {
  i18n.global.locale.value = loc;
  localStorage.setItem(STORAGE_KEY, loc);
  document.documentElement.setAttribute("lang", loc);
}

export const SUPPORTED_LOCALES = SUPPORTED;

document.documentElement.setAttribute("lang", i18n.global.locale.value);

export default i18n;
